<template>
  <div>
    <table class="comparison-plan-table-parts">
      <thead class="comparison-plan-table-parts__header">
        <tr>
          <th></th>
          <th class="comparison-plan-table-parts__header-free">
            {{ $tc('SignupPage.SelectPlanPage.comparison.free') }}
          </th>
          <th class="comparison-plan-table-parts__header-paid">
            {{ $t('SignupPage.SelectPlanPage.comparison.membership') }}
          </th>
        </tr>
      </thead>
      <tbody class="comparison-plan-table-parts__list">
        <comparison-plan-table-item-parts
          v-for="(item, index) in planData"
          :key="`comparison-plan-item-parts${index}`"
          :label="item.label"
          :free="item.free"
          :freeFootnote1="item.freeFootnote1"
          :freeFootnote2="item.freeFootnote2"
          :paid="item.paid"
        />
      </tbody>
    </table>
    <!-- TODO: SFgo's Race Key Points, SFgo Race Rank, Standings実装後に表示 -->
    <!-- <div class="comparison-plan-table-parts__footnote">
      <div>
        ※<span class="comparison-plan-table-parts__footnote-number">1</span
        >{{ $tc('SignupPage.SelectPlanPage.comparison.footnote1') }}
      </div>
      <div>
        ※<span class="comparison-plan-table-parts__footnote-number">2</span
        >{{ $tc('SignupPage.SelectPlanPage.comparison.footnote2') }}
      </div>
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import I18n from '@/locales/I18n'
import ComparisonPlanTableItemParts from '@/components/common/MembershipPlan/ComparisonPlanTableItemParts.vue'

/**
 * プラン比較テーブル
 */
export default defineComponent({
  name: 'ComparisonPlanTableParts',
  components: {
    ComparisonPlanTableItemParts,
  },
  setup() {
    /**
     * プラン比較データ指定
     */
    const planData = [
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.freeMovie'),
        free: true,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.paidMovie'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.snsPost'),
        free: true,
        paid: true,
      },
      // TODO: SFgo's Race Key Points, SFgo Race Rank, Standingsは実装後に表示させる
      // {
      //   label: I18n.tc('SignupPage.SelectPlanPage.comparison.raceKeyPoints'),
      //   free: true,
      //   paid: true,
      //   freeFootnote1: true,
      // },
      // {
      //   label: I18n.tc('SignupPage.SelectPlanPage.comparison.raceRank'),
      //   free: true,
      //   paid: true,
      //   freeFootnote2: true,
      // },
      // {
      //   label: I18n.tc('SignupPage.SelectPlanPage.comparison.standings'),
      //   free: true,
      //   paid: true,
      //   freeFootnote2: true,
      // },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.freeRunMovie'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.qualifyingRaceMovie'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.finalRaceMovie'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.relayMovie'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.onboardMovie'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.highlight'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.telemetry'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.liveTiming'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.locationInformation'),
        free: false,
        paid: true,
      },
      {
        label: I18n.tc('SignupPage.SelectPlanPage.comparison.teamRadio'),
        free: false,
        paid: true,
      },
    ]

    return {
      planData,
    }
  },
})
</script>

<style lang="scss" scoped>
.comparison-plan-table-parts__footnote {
  width: min(100%, 768px);
  margin: 16px auto 0;
  font-family: $fontSignup;
  font-size: 13px;
}

.comparison-plan-table-parts {
  width: min(100%, 768px);
  margin: 0 auto;
  font-family: $fontSignup;
  @include fontSetTextMedium(12);

  letter-spacing: 0.02em;
  font-feature-settings: 'palt' on;

  &__header {
    text-align: center;
    border-bottom: 1px solid $black10;
    font-size: 13px;
    font-weight: 700;

    th {
      padding-bottom: 8px;
    }

    &--free {
      color: $black20;
    }

    &-paid {
      color: #00978e;
      font-size: 14px;
    }
  }

  &__footnote-number {
    font-size: 80%;
    margin-right: 4px;
  }
}
</style>
